export const SET_CATEGORIES = "SET_CATEGORIES";
export const SET_CATEGORIES_BENEFITS = "SET_CATEGORIES_BENEFITS";
export const SET_CATEGORY_TYPE = "SET_CATEGORY_TYPE";
export const SET_SUBCATEGORIES = "SET_SUBCATEGORIES"; 
export const SET_MODO = "SET_MODO"; 
export const SET_CATEGORIES_ID = "SET_CATEGORIES_ID";